import { axiosInstance } from "../config";
import i18n from "../i18n";

// One shared lookup of the visitor's country + regional (PPP) discount.
// The server decides both from the account's country, else the request IP —
// the same source checkout uses, so the price shown matches what Stripe charges.
let regionPromise = null;
export function getRegion() {
  if (!regionPromise) {
    regionPromise = axiosInstance
      .get("/billing/region-pricing")
      .then((r) => r.data || {})
      .catch(() => ({}));
  }
  return regionPromise;
}

// Main language per country, for languages the app has translations for.
const COUNTRY_LANG = {
  es: ["ES", "MX", "AR", "CO", "PE", "VE", "CL", "EC", "GT", "CU", "BO", "DO", "HN", "PY", "SV", "NI", "CR", "PA", "UY", "PR", "GQ"],
  fr: ["FR", "MC", "SN", "CI", "CM", "ML", "BF", "NE", "TG", "BJ", "GA", "CG", "CD", "MG", "HT", "GN", "TD"],
  de: ["DE", "AT", "LI"],
  it: ["IT", "SM", "VA"],
  ja: ["JP"],
  ko: ["KR"],
  ru: ["RU", "BY", "KZ", "KG"],
  vi: ["VN"],
  id: ["ID"],
  "zh-CN": ["CN", "SG"],
  "zh-TW": ["TW", "HK", "MO"],
};
const LANG_BY_COUNTRY = Object.fromEntries(
  Object.entries(COUNTRY_LANG).flatMap(([lng, ccs]) => ccs.map((cc) => [cc, lng]))
);

// Switch to the visitor's country language, once per device, and only when the
// app would otherwise show English (their browser is English or unsupported).
// A browser already set to a supported language, or a choice made in the
// language switcher, always wins.
const GEO_FLAG = "clipbait_lang_geo";
export function applyCountryLanguage() {
  try {
    if (localStorage.getItem(GEO_FLAG)) return;
  } catch { return; }
  if (!(i18n.resolvedLanguage || i18n.language || "en").startsWith("en")) {
    try { localStorage.setItem(GEO_FLAG, "browser"); } catch { /* ignore */ }
    return;
  }
  getRegion().then(({ country }) => {
    const lng = country && LANG_BY_COUNTRY[String(country).toUpperCase()];
    try { localStorage.setItem(GEO_FLAG, lng || "none"); } catch { /* ignore */ }
    if (lng) i18n.changeLanguage(lng);
  });
}

export function markLanguageChosen() {
  try { localStorage.setItem(GEO_FLAG, "user"); } catch { /* ignore */ }
}
